import { Component, HostBinding, Input } from '@angular/core';

import { EventScoreboard, PairScore, SetGameScore, SetScore, SportType } from '@frontend/sports/betting-offer/feature/model';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';

@Component({ template: '' })
export abstract class SetGameScoreboardBaseComponent {
    @Input() scoreboard: EventScoreboard;
    @Input() hasExtended: boolean;
    @HostBinding('class.hidden')
    get hidden(): boolean {
        return !this.score || !this.score.participant1 || !this.score.participant2;
    }

    constructor(public sitecore: Sitecore) {}

    get score(): SetGameScore {
        return this.scoreboard.score as SetGameScore;
    }

    get points(): PairScore<string> | undefined {
        if (this.scoreboard.sportType !== SportType.Tennis || this.hidden) {
            return;
        }

        if (!this.score.participant1.points && !this.score.participant2.points) {
            return;
        }

        return {
            participant1: this.score.participant1.points as string,
            participant2: this.score.participant2.points as string,
        };
    }

    get games(): PairScore<number | string> | undefined {
        if (this.hidden) {
            return;
        }

        const index = this.score.participant1WonSets + this.score.participant2WonSets;
        if (index >= this.score.participant1.sets.length) {
            return;
        }

        return {
            participant1: this.score.participant1.sets[index].points || 0,
            participant2: this.score.participant2.sets[index].points || 0,
        };
    }

    get sets(): PairScore<number> | undefined {
        if (this.hidden) {
            return;
        }

        return {
            participant1: this.score.participant1WonSets,
            participant2: this.score.participant2WonSets,
        };
    }

    getHighlightedSetClass(set: SetScore): string {
        if (set.setWon) {
            return 'set-won';
        } else if (set.points === '-') {
            return 'empty-set';
        }

        return '';
    }
}
